export default "__VITE_ASSET__72279fff__"